import React, { useState } from 'react';
import './Photos.css';

// Import your real-life photos
import photo1 from './../assets/photos/photo1.jpeg';
import photo2 from './../assets/photos/photo2.jpeg';
import photo3 from './../assets/photos/photo3.jpeg';
import photo4 from './../assets/photos/photo4.png';
import photo5 from './../assets/photos/photo5.png';

export function Photos() {
  const [selectedPhoto, setSelectedPhoto] = useState(null);

  const photos = [
    { id: 1, src: photo1, alt: 'Photo 1 description' },
    { id: 2, src: photo2, alt: 'Photo 2 description' },
    { id: 3, src: photo3, alt: 'Photo 3 description' },
    { id: 4, src: photo4, alt: 'Photo 4 description' },
    { id: 5, src: photo5, alt: 'Photo 5 description' },
  ];

  const openPhoto = (photo) => {
    setSelectedPhoto(photo);
  };

  const closePhoto = () => {
    setSelectedPhoto(null);
  };

  return (
    <div className="photos">
      <div className="note">
        Some of my highlights over the years! Click on a photo to see the photo in closer detail! A comment section is coming soon :)
      </div>
      <div className="photos__grid">
        {photos.map((photo) => (
          <div key={photo.id} className="photos__item" onClick={() => openPhoto(photo)}>
            <img src={photo.src} alt={photo.alt} className="photos__image" />
          </div>
        ))}
      </div>

      {selectedPhoto && (
        <div className="photo__modal" onClick={closePhoto}>
          <div
            className="photo__modal-content"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside content
          >
            <button className="photo__modal-close" onClick={closePhoto}>
              &times;
            </button>
            <div className="photo__modal-image-wrapper">
              <img
                src={selectedPhoto.src}
                alt={selectedPhoto.alt}
                className="photo__modal-image"
              />
            </div>
            <div className="photo__modal-description">
              <h2>Photo Description</h2>
              <p>{selectedPhoto.alt}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}